<ot-checkbox2 [formControl]="group.get(config.field)">{{config.label}}</ot-checkbox2>
